/*
 * @providesModule TrackTelemetryEvent
 */

import {
  safelyExecute,
  getGlobalContext,
  getUserDetails,
  getUserWalletDetails,
} from 'TelemetryUtils';
import type {TelemetryPayload, TrackTelemetryEventOptions} from 'TelemetryTypes';
import {integrations} from 'TelemetryIntegrations';

export const trackTelemetryEvent = (options: TrackTelemetryEventOptions): void => {
  try {
    const {
      event,
      payload = {},
      includeUserDetails = false,
      includeUserWalletDetails = false,
    } = options;

    const globals = getGlobalContext();

    let updatedPayload: TelemetryPayload = {event: {...globals, ...payload}};

    if (includeUserDetails) {
      updatedPayload.user = {...getUserDetails()};
    }

    if (includeUserWalletDetails) {
      updatedPayload.event = {...globals, ...payload, ...getUserWalletDetails()};
    }

    setTimeout(() => {
      try {
        for (const [name, module] of Object.entries(integrations)) {
          if (!module?.enabled) continue;
          const handler = module.handlers?.[event];
          if (typeof handler === 'function') {
            safelyExecute(() => handler(updatedPayload), {
              scope: 'telemetry',
              integration: name,
              event,
            });
          }
        }
      } catch (error) {
        console.error('Error in telemetry track setTimeout:', error);
      }
    }, 0);
  } catch (error) {
    console.error('Error in telemetry track function:', error);
  }
};
